export const DATE_PRESET_KEYS = ['this_month', 'last_month', 'last_15_days', 'last_7_days'];

export const THRESHOLDS = {
  suspend: 0.15,
  warning: 0.30,
};

export const getTypeTranslation = (t, type) => {
  const translations = {
    credit: {
      label: t('wallet-overview.ledger.type.credit'),
      color: 'bg-success-subtle text-success',
    },
    debit: {
      label: t('wallet-overview.ledger.type.debit'),
      color: 'bg-danger-subtle text-danger',
    },
  };
  return translations[type] ?? {
    label: t('wallet-overview.ledger.type.unknown'),
    color: 'bg-secondary-subtle text-secondary',
  };
};
